document.addEventListener(
  'click',
  function (event) {
    const swatch = event.target.closest('[data-card-swatch]');

    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productCard =
      swatch.closest('.product-card-wrapper') ||
      swatch.closest('.card-wrapper');

    if (!productCard) return;

    const variantImage = swatch.dataset.variantImage;
    const variantSrcset = swatch.dataset.variantImageSrcset;
    const variantUrl = swatch.dataset.variantUrl;

    /*
     * Do nothing when the variant has no assigned image.
     * Do not unexpectedly redirect the customer.
     */
    if (!variantImage) {
      console.warn(
        'No variant image assigned for variant:',
        swatch.dataset.variantId
      );
      return;
    }

    const cardMedia = productCard.querySelector('.card__media');

    if (!cardMedia) return;

    const images = cardMedia.querySelectorAll('img');

    if (!images.length) return;

    /*
     * Update the primary product-card image.
     */
    const primaryImage = images[0];

    primaryImage.src = variantImage;

    if (variantSrcset) {
      primaryImage.srcset = variantSrcset.trim();
    } else {
      primaryImage.removeAttribute('srcset');
    }

    primaryImage.removeAttribute('data-src');
    primaryImage.removeAttribute('data-srcset');

    /*
     * Prevent Dawn's secondary hover image from covering
     * the newly selected variant image.
     */
    if (images.length > 1) {
      images[1].src = variantImage;

      if (variantSrcset) {
        images[1].srcset = variantSrcset.trim();
      } else {
        images[1].removeAttribute('srcset');
      }

      images[1].removeAttribute('data-src');
      images[1].removeAttribute('data-srcset');
    }

    /*
     * Update product-card links to the selected variant.
     */
    if (variantUrl) {
      productCard
        .querySelectorAll('.card__heading a, .card__media a')
        .forEach(function (link) {
          link.href = variantUrl;
        });
    }

    /*
     * Update selected swatch styling.
     */
    productCard
      .querySelectorAll('[data-card-swatch]')
      .forEach(function (item) {
        item.classList.remove('is-selected');
        item.removeAttribute('aria-current');
      });

    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-current', 'true');
  },
  true
);